// Field name constants for Contact Collection
export const FIELD_EMAIL = 'email';
export const FIELD_PHONE = 'phone';
export const FIELD_SOURCE_DETAIL = 'sourceDetail';
export const FIELD_ACTION = 'action';
export const FIELD_SELECTED = 'selected';
export const FIELD_FULL_NAME = 'fullName';
export const FIELD_COMPANY_NAME = 'companyName';
export const FIELD_JOB_TITLE = 'jobTitle';
export const FIELD_CREATED_AT = 'createdAt';
export const FIELD_SOURCE = 'source';
export const FIELD_CARD_NAME = 'cardName';
export const FIELD_ID = 'id';
export const FIELD_NOTES = 'notes';
export const FIELD_TAGS = 'tags';
export const FIELD_PROMO_ACTION = 'promoSettings';
export const FIELD_STATUS = 'status';
export const FIELD_SALES = 'sales';
export const FIELD_REPLIES = 'replies';
export const FIELD_OUTBOUND_MESSAGE = 'outboundMessage';
export const FIELD_LAST_MESSAGE_PREVIEW = 'lastMessagePreview';
export const FIELD_FLOW = 'flow';
export const FIELD_LAST_UPDATED = 'updatedAt';
export const FIELD_STATUS_SUBSCRIBE = 'statusSubscribe';
export const FIELD_UNSUBSCRIBED_AT = 'unsubscribedAt';
export const FIELD_ASSIGN_TO = 'assignedTo';
export const FIELD_RECORDS = 'records';

// New fields according to feedback
export const FIELD_CARD_OFFERS = 'cardOffers';
export const FIELD_INTENT = 'intent';
export const FIELD_VOICE_NOTES_SUMMARY = 'voiceNotesSummary';
export const FIELD_NOTES_PREVIEW = 'notesPreview';
export const FIELD_LAST_REPLY = 'lastReply';
export const FIELD_TOTAL_MESSAGES_SENT = 'totalMessagesSent';
export const FIELD_SENTIMENT = 'sentiment';

// Sorting constants
export const SORT_ASC = 'asc';
export const SORT_DESC = 'desc';

// API parameter constants
export const PARAM_LIMIT = 'limit';
export const PARAM_PAGE = 'page';
export const PARAM_SEARCH = 'search';
export const PARAM_SORT_BY = 'sortBy';
export const PARAM_SORT_ORDER = 'sortOrder';

export const getCustomerInfoFields = (t: (key: string) => string) => [
  {
    label: t('RAW_CONTACT_COLLECTION.FORM.FULL_NAME'),
    name: 'fullName',
    type: 'text',
  },
  {
    label: t('RAW_CONTACT_COLLECTION.FORM.EMAIL'),
    name: 'email',
    type: 'email',
  },
  {
    label: t('RAW_CONTACT_COLLECTION.FORM.PHONE'),
    name: 'phone',
    type: 'text',
  },
  {
    label: t('RAW_CONTACT_COLLECTION.FORM.CARD_NAME'),
    name: 'cardName',
    type: 'text',
  },
  {
    label: t('RAW_CONTACT_COLLECTION.FORM.PROMO_ACTION'),
    name: 'promoActions',
    type: 'select',
  },
]

export const getCustomerInsightsFields = (t: (key: string) => string) => [
  {
    label: t('RAW_CONTACT_COLLECTION.FORM.TAGS'),
    name: 'tags',
    type: 'select',
  },
  {
    label: t('RAW_CONTACT_COLLECTION.FORM.NOTES'),
    name: 'notes',
    type: 'text',
    isTextArea: true,
  },
  {
    label: t('RAW_CONTACT_COLLECTION.FORM.SALE_STATUS'),
    name: 'sales',
    type: 'checkbox',
  },
  {
    label: t('RAW_CONTACT_COLLECTION.FORM.ASSIGN_TO'),
    name: 'assignedTo',
    type: 'select',
  },
]

export const getFields = (t: (key: string) => string) => [
  {
    label: t('RAW_CONTACT_COLLECTION.FORM.FULL_NAME'),
    name: 'fullName',
    type: 'text',
  },
  {
    label: t('RAW_CONTACT_COLLECTION.FORM.EMAIL'),
    name: 'email',
    type: 'email',
  },
  {
    label: t('RAW_CONTACT_COLLECTION.FORM.PHONE'),
    name: 'phone',
    type: 'text',
  },
  {
    label: t('RAW_CONTACT_COLLECTION.FORM.CARD_NAME'),
    name: 'cardName',
    type: 'text',
  },
  {
    label: t('RAW_CONTACT_COLLECTION.FORM.TAGS'),
    name: 'tags',
    type: 'select',
  },
  {
    label: t('RAW_CONTACT_COLLECTION.FORM.PROMO_ACTION'),
    name: 'promoActions',
    type: 'select',
  },
  {
    label: t('RAW_CONTACT_COLLECTION.FORM.NOTES'),
    name: 'notes',
    type: 'text',
    isTextArea: true,
  },
]
export const S3_VOICE_NAME = 'VOICE';
export const S3_VOICE_BUCKET_NAME = 'dev-voices';
